module.exports = __webpack_public_path__ + "1ba9e171ca118e6244bc063cc53a7b25.fbx";